import styled, { css } from 'styled-components';
import ColorConstants from '@shared/constants/ColorConstants';

export const LeaderBoardWrapper = styled.div`
  align-items: center;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  > div{
    margin-right: 25px;
  }

  @media screen and (max-width: 700px) {
    align-items: flex-start;
    flex-direction: column;
    > div{
        margin-right: 0;
      }
  }
`;

export const LeaderBoardTitle = styled.div`
    color: ${ColorConstants.white};
    font-size: 15px;
    text-align: right;
    ${({ isDesktop }) => isDesktop && css`
            font-size: 14px;
            font-family: 'Helvetica';
            color: ${ColorConstants['black-50%']};
        `};
    @media screen and (max-width: 1200px) {
        font-size: 14px;
    }
`;
